export default __webpack_public_path__ + "static/media/minus-grey.94c859bb.svg";